var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "bottom-bar"
  }, _vm._l(_vm.imgSrc, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "img-con",
      on: {
        click: function click($event) {
          return _vm.toPage(item.path, index);
        }
      }
    }, [_c("img", {
      staticClass: "img",
      attrs: {
        src: item.isActive ? item.avtive : item.normal,
        alt: ""
      }
    })]);
  }), 0);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };